import { TextSkeleton } from '@/components/Skeleton';

import { fontStyles } from '@/styles/typography';

import { InfoCircleSolidSmallIcon } from '@/ui/Icons/InfoCircleSolidSmallIcon';
import {
  MatchaTooltip,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipBottomSheet,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

import { routes } from '@/utils/routes';

interface MaxSlippageProps {
  isLoading?: boolean;
  slippagePercentageFormatted?: number;
  isGasless?: boolean;
  /** Auto slippage active: prefix the value with "Auto ·". */
  isAutoSlippage?: boolean;
}

export const MaxSlippageLineItemWithPopover = ({
  isLoading,
  slippagePercentageFormatted,
  isGasless,
  isAutoSlippage,
}: MaxSlippageProps) => {
  return (
    <div className="flex items-center justify-between h-8 w-full">
      <div
        className={fontStyles({
          variant: 'BODY_MD',
          class: 'flex items-center text-token-gray-800',
        })}
      >
        Max. slippage
        <MatchaTooltip delayDuration={0}>
          <MatchaTooltipTrigger>
            <span>
              <InfoCircleSolidSmallIcon className="text-token-gray-700 ml-1 flex justify-center cursor-default hover:cursor-default" />
            </span>
          </MatchaTooltipTrigger>
          <MatchaTooltipContent>
            {' '}
            {isGasless ? (
              <span>
                Allowable difference between the expected and executed prices of a trade. Matcha
                Auto provides full protection from frontrunning bots and MEV.&nbsp;
                <a
                  href={`${routes.BLOG}/article/what-is-mev`}
                  target="_blank"
                  className="text-token-purple-900"
                >
                  Learn more
                </a>
              </span>
            ) : (
              `Allowable difference between the expected and executed prices of a trade. Your transaction will revert if price changes unfavorably by more than this percentage.`
            )}
          </MatchaTooltipContent>
          <MatchaTooltipPopover className="max-w-[380px]" />
          <MatchaTooltipBottomSheet header="Max. slippage" />
        </MatchaTooltip>
      </div>
      {isLoading ? (
        <TextSkeleton width={80} height={14} />
      ) : (
        <div className="flex items-center">
          <span
            className={fontStyles({
              variant: 'BODY_MD',
              class: 'text-token-gray-800 flex items-center',
            })}
          >
            {isAutoSlippage && <>Auto ·&nbsp;</>}
            <span className="text-token-gray-1600">{slippagePercentageFormatted}%</span>
          </span>
        </div>
      )}
    </div>
  );
};
